var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[_c('router-view')],1),_vm._v(" "),(_vm.$store.state.cookieNoticeShow)?_c('CookieNotice',{on:{"notAccept":_vm.notAccept}}):_vm._e(),_vm._v(" "),(_vm.$store.state.iPShow)?_c('IpNotice',{attrs:{"message":_vm.ipMessage},on:{"cancel":_vm.cancel,"confirm":_vm.confirm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59ef1069","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 